import { Navigate, Route, Routes } from "react-router-dom";
import Login from "../pages/Login";
import AdminLogin from "../pages/AdminLogin";
import AdminDashboard from "../pages/AdminDashboard";
import VerifyEmail from "../pages/VerifyEmail";
import MainLayout from "../pages/MainLayout";
import UserDashboard from "../pages/UserDashboard";
import ArticleDetails from "../pages/ArticleDetails";
import JournalDetails from "../pages/JournalDetails";
import TermsConditions from "../pages/TermsConditions";
import Signature from "../pages/Signature";
import {
  ProtectedUserRoute,
  ProtectedAdminRoute,
  PublicOnlyUserRoute
} from "./RouteGuards";

export default function AppRoutes() {
  return (
    <Routes>
      <Route element={<ProtectedUserRoute />}>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<UserDashboard />} />
          <Route path="author-details" element={<ArticleDetails />} />
          <Route path="contact" element={<Navigate to="/author-details" replace />} />
          <Route path="journal-details" element={<JournalDetails />} />
          <Route path="terms-and-conditions" element={<TermsConditions />} />
          <Route path="signature" element={<Signature />} />
        </Route>
      </Route>
      <Route element={<PublicOnlyUserRoute />}>
        <Route path="/login" element={<Login />} />
      </Route>
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/admin" element={<AdminLogin />} />
      <Route element={<ProtectedAdminRoute />}>
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
      </Route>
      <Route path="/dashboard-admin" element={<Navigate to="/admin/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

